export default __webpack_public_path__ + "static/media/close.c5d43557.svg";